/**
 * React component that renders the 404 page.
 * It reflects the exact same 404 page for feature parity.
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import cx from 'classnames'
import Typography from 'components/theme/Typography'
import Layout from 'components/Layout'
import Navbar from 'components/Navbar'
import courseraLogo from 'static/images/logos/coursera-wordmark-blue.svg'
import notFoundIllustration from 'static/images/illustrations/404.svg'
import styles from './404.module.scss'

const NotFoundPage = (props) => (
  <Layout
    {...props}
    title="Page not found"
    slug="404"
    logo={{
      alt: 'coursera-logo',
      src: {
        file: {
          url: courseraLogo,
        },
      },
    }}
    disableFooter
    noindex>
    <Navbar logo={courseraLogo} alt="coursera-logo" />
    <div className={cx(styles.page)}>
      <img src={notFoundIllustration} alt="404" className={cx(styles.illustration)} />
      <div className={cx(styles.message)}>
        <Typography variant="h2" className="my-md font-weight-regular">
          We were not able to find the page you're looking for.
          <br />
          {`Try `}
          <a href="https://www.coursera.org/browse">browsing our course catalog</a>
          {` or `}
          <a href="https://www.coursera.org/courses">searching our course catalog</a>
          {` instead.`}
        </Typography>
        <Typography variant="h4" className="mb-md">You might also find these links helpful:</Typography>
        <a className={cx(styles.link)} href="https://www.coursera.org/degrees">Online Degrees</a>
        <a className={cx(styles.link)} href="https://www.coursera.org/enterprise">Coursera for Business</a>
        <a className={cx(styles.link)} href="https://blog.coursera.org/">Coursera Blog</a>
      </div>
    </div>
  </Layout>
)

export default NotFoundPage;
